import React from 'react';
import { hasAnyPermission, hasPermission } from './rolePermissions';

/**
 * Renders children only when the current user has the required permission(s).
 */
export function PermissionGate({
	permission,
	anyOf,
	children,
	fallback = null
}) {
	const allowed = anyOf ? hasAnyPermission(anyOf) : hasPermission(permission);

	if (!allowed) {
		return fallback;
	}

	return <>{children}</>;
}
